// Offers Module Layout - Shared wrapper with tabs for all Offers pages
import { useNavigate, useLocation } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import {
  LayoutDashboard,
  Calculator,
  FileSpreadsheet,
  MessageSquare,
  Mail,
  Megaphone
} from "lucide-react";

// Tabs for the Offers Module
const OFFERS_TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/offers" },
  { id: "pricing", label: "Pricing & Quotes", icon: Calculator, path: "/offers/pricing" },
  { id: "rate-cards", label: "Rate Cards", icon: FileSpreadsheet, path: "/offers/rate-cards" },
  { id: "campaigns", label: "Rate Campaigns", icon: Megaphone, path: "/offers/campaigns" },
  { id: "followups", label: "Follow-ups", icon: MessageSquare, path: "/offers/followups" },
  { id: "advisory", label: "Customer Advisory", icon: Mail, path: "/customer-advisory" }
];

export default function OffersModuleLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab based on current path
  const getActiveTab = () => {
    if (location.pathname.includes("/offers/pricing")) return "pricing";
    if (location.pathname.includes("/offers/rate-cards")) return "rate-cards";
    if (location.pathname.includes("/offers/campaigns")) return "campaigns";
    if (location.pathname.includes("/offers/followups")) return "followups";
    if (location.pathname.includes("/customer-advisory")) return "advisory";
    return "dashboard";
  };

  const activeTab = getActiveTab();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      <Navbar />
      
      {/* Spacer for fixed navbar */}
      <div className="h-14"></div>
      
      {/* Offers Module Header with Tabs - Fixed below navbar */}
      <div className="bg-white border-b sticky top-14 z-40">
        <div className="max-w-[1800px] mx-auto px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <h1 className="text-xl font-bold text-slate-900">Offers Module</h1>
              <p className="text-sm text-muted-foreground">Manage quotes, pricing, and rate cards</p>
            </div>
            <div className="flex items-center gap-2 bg-slate-100 rounded-lg p-1">
              {OFFERS_TABS.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => navigate(tab.path)}
                    data-testid={`offers-tab-${tab.id}`}
                    className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
                      activeTab === tab.id
                        ? "bg-white text-primary shadow-sm"
                        : "text-slate-600 hover:text-slate-900 hover:bg-white/50"
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    {tab.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="offers-module-content">
        {children}
      </div>
    </div>
  );
}
